import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Col, Row } from 'antd';
import { Weather } from 'ontraccr-common';
import WeatherReportTable from './WeatherReportTable';
import DailySnapshotTable from './DailySnapshotTable';

export default function OntraccrWeather({
  data = {},
  loading,
  showDailySnapshot,
  showWeatherReport,
  startHour,
  endHour,
} = {}) {
  const weatherReportData = useMemo(() => Weather.parseWeatherReport(data), [data]);
  const dailySnapshotData = useMemo(() => Weather.parseDailySnapshot(data, startHour, endHour), [data, startHour, endHour]);

  return (
    <Row>
      <Col>
        {showWeatherReport && (
          <Row style={{ width: '100%' }}>
            <WeatherReportTable raw={data} data={[weatherReportData]} loading={loading} />
          </Row>
        )}
        {showDailySnapshot && (
          <Row style={{ width: '100%' }}>
            <DailySnapshotTable raw={data} data={[dailySnapshotData]} loading={loading} startHour={startHour} endHour={endHour} />
          </Row>
        )}
      </Col>
    </Row>
  );
}

OntraccrWeather.propTypes = {
  data: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  loading: PropTypes.bool,
  showDailySnapshot: PropTypes.bool,
  showWeatherReport: PropTypes.bool,
  startHour: PropTypes.number,
  endHour: PropTypes.number,
};

OntraccrWeather.defaultProps = {
  data: {},
  loading: false,
  showDailySnapshot: true,
  showWeatherReport: true,
  startHour: 6,
  endHour: 21,
};
